import ky from "ky";
import { getDomain, redirectToLogin } from "./helpers.js";
import { reportClientError } from "./reportClientError";
import Vue from "vue";
import store from "../store";

function getUrl(url) {
    return getDomain() + url;
}

const actions = {
    async get(progressBar, url, queryParams = undefined) {
        progressBar.start();

        const searchParams = queryParams
            ? new URLSearchParams(queryParams)
            : "";
        try {
            const response = await ky(url, {
                prefixUrl: getDomain(),
                timeout: 60000,
                searchParams,
                headers: {
                    Authorization: store.state.authentication.token,
                },
            }).json();

            progressBar.finish();

            return response;
        } catch (error) {
            if (error.response && error.response.status == 401) {
                redirectToLogin();

                return;
            }

            if (!error.response) {
                reportClientError({
                    message: error.message || "Network error",
                    url: url,
                    method: "GET",
                    statusCode: "0",
                });
            }

            Vue.notify({
                group: "notification",
                text: "An error has occurred",
                type: "error",
            });

            progressBar.finish();

            throw new Error("An error has occurred");
        }
    },
    async post(progressBar, url, { data, queryParams }) {
        progressBar.start();

        const searchParams = queryParams
            ? new URLSearchParams(queryParams)
            : "";

        try {
            const response = await ky.post(url, {
                prefixUrl: getDomain(),
                timeout: 60000,
                json: data,
                searchParams,
                headers: {
                    Authorization: store.state.authentication.token,
                },
            });

            progressBar.finish();

            return response;
        } catch (error) {
            if (!error.response) {
                reportClientError({
                    message: error.message || "Network error",
                    url: url,
                    method: "POST",
                    statusCode: "0",
                });
            }

            Vue.notify({
                group: "notification",
                text: "An error has occurred",
                type: "error",
            });

            progressBar.finish();

            throw new Error("An error has occurred");
        }
    },
};

export default actions;
